export default __webpack_public_path__ + "static/media/intro-wave-light.6fbc1925.webp";